import React, { useEffect, useRef, useState } from "react";
import { motion } from "framer-motion";
import { TextInput } from "../../Components";
import {
    influencerlistService,
} from '../../Services';
export default function AddListandInfluencerToList({ handleSearch, setTab, setToastList, toastList, setTabModal, selectedInfluencer }) {
    const createList = useRef(null);
    const [form, setForm] = useState({
        name: "",
        influencer_id: selectedInfluencer.id,
        influencer_type: selectedInfluencer.type ? selectedInfluencer.type : selectedInfluencer.inf_user_type
    });
    console.log(form)
    const [error, setError] = useState(false);
    const [disableCreateButton, setDisableCreateButton] = useState(false);
    const updateForm = (data) => {
        setForm({ ...form, ...data });
    };
    const setInput = (key) => (event) =>
        updateForm({ [key]: event.target.value });

    const submitBtnClick = () => {
        if (form.name === "") {
            setError(true);
        } else {
            saveList(form);
        }
    };
    const saveList = async () => {
        try {
            let param = {
                name: form.name,
                influencers: [{ "id": form.influencer_id, "type": form.influencer_type }]
            }
            const res = await influencerlistService.createListandAddInfluencer(param);
            if (res.success == true) {
                setTabModal("main")
                handleSearch();
                addToast({ error: false, date: new Date(), msg: res.message });
            }
        } catch (err) {
            addToast({
                error: true,
                date: new Date(),
                msg: typeof err === 'string'
                    ? err.replace(/<[^>]*>/g, '')
                    : err.message,
            });
            setTabModal("main")
        }
    };
    const addToast = data => {
        const newToastList = [...toastList];
        if (data.msg) {
            if (data.msg[data.msg.length - 1] === ".")
                data.msg = data.msg.slice(0, -1);
        }
        newToastList.push({ ...data, id: `${Date.now()}-${toastList.length}` });
        setToastList(newToastList);
    };
    useEffect(() => {
        const keyDownHandler = event => {
            if (event.key === 'Enter') {
                createList.current.click();
            }
        };
        document.addEventListener('keydown', keyDownHandler);
        return () => {
            document.removeEventListener('keydown', keyDownHandler);
        };
    }, [form]);
    return (
        <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4 }}
            exit={{ opacity: 0, y: 30 }}
            className="assetsAdd"
        >
            <div className="assetsAdd__form">
                <div className="assetsAdd__form-title">
                    <h3 className="big">Name Your List</h3>
                </div>
                <div className="assetsAdd__form-inner">
                    <div className="assetsAdd__form-head">
                        <TextInput
                            value={form.name}
                            type="text"
                            onChange={setInput("name")}
                            error={error}
                            errorText="Please enter list name"
                            autoFocus
                        />
                    </div>
                </div>
                <div className="campaignsCreate__btns">
                    <div class="campaignsCreate__btns-row"></div>
                    <button ref={createList} className="button primary" onClick={submitBtnClick} disabled={disableCreateButton}>
                        Add To List
                    </button>
                </div>
            </div>

        </motion.div>
    );
}
